import { render, staticRenderFns } from "./CouponClaimValidDays.vue?vue&type=template&id=5dfc1160"
import script from "./CouponClaimValidDays.vue?vue&type=script&lang=js"
export * from "./CouponClaimValidDays.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports